export default "__VITE_ASSET__CiS5C6tW__"